import React from "react";
import facebook from "../../assets/images/facebook.png";
import instagram from "../../assets/images/instagram.png";
import kakaotalk from "../../assets/images/kakaotalk.png";

const Footer = () => {
  const pathname = window.location.pathname.split("/");
  const moveToPolicy = (e) => window.open(`/policy/${e.target.id}`);

  return (
    <>
      <div
        className="footer container"
        style={{
          marginTop:
            pathname[1] === "" || pathname[1] === "mycorp" ? "60px" : "",
        }}
      >
        <div className="inner_container">
          <div className="footer_head">
            <div className="footer_contact">
              <ul className="policy_list" style={{ fontSize: "16px" }}>
                <li id="term_policy" onClick={moveToPolicy}>
                  이용약관
                </li>
                <li id="youth_policy" onClick={moveToPolicy}>
                  청소년보호정책
                </li>
                <li id="personal_policy" onClick={moveToPolicy}>
                  개인정보처리방침
                </li>
                <li id="copyright_policy" onClick={moveToPolicy}>
                  저작권보호정책
                </li>
                <li id="ethics_policy" onClick={moveToPolicy}>
                  인터넷신문윤리강령
                </li>
              </ul>
              <span>
                주소: 경기도 성남시 분당구 판교로255번길 35(삼평동,판교
                실리콘파크) (우) 13486ㅣ전화 : 031-8039-7035
              </span>
              <span>
                등록번호: 경기 아 53853ㅣ등록일자 : 2023.11.06ㅣ발행인 :
                ㈜퍼스널뉴스서비스 박석준ㅣ편집인 : 박석준ㅣ청소년보호책임자 :
                박석준
              </span>
              <span>
                사업자명: 주식회사 퍼스널뉴스서비스 ㅣ사업자등록번호 :
                510-88-01412 ㅣ 대표자명 : 박석준
              </span>
            </div>
            <div className="footer_social">
              <a
                href="https://www.facebook.com/people/2digit/100068410328515/?modal=admin_todo_tour"
                target="_blank"
                rel="noreferrer"
              >
                <img src={facebook} alt="facebook logo" />
              </a>
              <a
                href="https://www.instagram.com/news_salad_2digit/?hl=ko"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} alt="instagram logo" />
              </a>
              <a
                href="https://pf.kakao.com/_AUixjK"
                target="_blank"
                rel="noreferrer"
              >
                <img src={kakaotalk} alt="kakaotalk logo" />
              </a>
            </div>
          </div>
          <div className="copyright">
            Copyright©2023 Personal News Service. All Rights Reserved
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
